import logo from './logo.svg';
import React from 'react';
import { Route }from "react";
import './App.css';

export default function App(collection) {
  let btc_price = collection.collection.USD.rate_float;
  let meals = Math.round(btc_price / 0.1);
  meals = meals.toLocaleString();
  //1.26 from https://cdn.wfp.org/2020/plate-of-food/

  if (meals !== undefined){
    return (
      <div className="App">
        <header className="App-header">
          <p style={{fontSize:60, color:"black"}}>
            A single Bitcoin could provide <p style={{fontWeight: "bold", color:"lime"}}> {meals} meals  </p> for those in need.
          </p>
          <p style={{fontSize:20, color:"white"}}><a href="https://secure.feedingamerica.org/site/Donation2">donate to your local food bank instead of speculating on crypto.</a></p>
          <p style={{fontSize:10, color:"purple"}}>Meal pricing data courtesy of Feeding America. BTC data from Coindesk.</p>
        </header>
      </div>
    );
  } else {
    return (<p>
      loading...
    </p>)
  }
}

//export default App;
